<div class="list-page">
  <h2 style="margin-top: 60px">Nykyiset sopimukset</h2>
  <div style="padding-left: 20px; padding-top: 10px">
    @if (templateUrlLataa()) {
      <mat-spinner [diameter]="24"></mat-spinner>
    }
    @if (!templateUrlLataa()) {
      <div style="margin-bottom: 1em">
        <div style="margin-bottom: 0.5em">Suomi (FI)</div>
        @if (templateUrlFi()) {
          <iframe [src]="templateUrlFi()" style="width: 100%; height: 800px; border: 1px solid #ccc"></iframe>
        }
      </div>
      <div>
        <div style="margin-bottom: 0.5em">Englanti (EN)</div>
        @if (templateUrlEn()) {
          <iframe [src]="templateUrlEn()" style="width: 100%; height: 800px; border: 1px solid #ccc"></iframe>
        }
      </div>
    }
  </div>

  <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em">
    @if (julkaiseEnabledObservable | async) {
      <app-primary-button (click)="julkaise()" actionId="Avasi dialogin: Julkaise sopimukset" [actionContext]="$any(lomake().value())">Julkaise uusi versio</app-primary-button>
    }
  </div>

  <h2>Liitteet</h2>
  <div style="padding-left: 20px; padding-top: 10px">
    @if (liitteetLataa()) {
      <mat-spinner [diameter]="24"></mat-spinner>
    }
    @if (!liitteetLataa()) {
      @for (liitetyyppi of liitetyypit; track liitetyyppi) {
        <div style="margin-bottom: 2em">
          <h3>{{ 'sopimus-ja-ehdot.liite-' + liitetyyppi | translate | async }}</h3>
          <div style="display: flex; gap: 2em; margin-bottom: 1em; align-items: center">
            <div style="display: flex; align-items: center; gap: 1em">
              <input type="file" accept=".pdf" style="display: none" #fiLiiteInput (change)="onLiiteFileChange(liitetyyppi, 'fi', $event)" />
              <app-primary-button (click)="fiLiiteInput.click()" [actionId]="'Valitse liite FI: ' + liitetyyppi" [disabled]="liiteUploadStatus()[liitetyyppi] === 'uploading'"> Valitse FI </app-primary-button>
              @if (liiteStatuses()[liitetyyppi]?.fi === 'selected') {
                <mat-icon style="color: #1976d2">attach_file</mat-icon>
              }
            </div>
            <div style="display: flex; align-items: center; gap: 1em">
              <input type="file" accept=".pdf" style="display: none" #enLiiteInput (change)="onLiiteFileChange(liitetyyppi, 'en', $event)" />
              <app-primary-button (click)="enLiiteInput.click()" [actionId]="'Valitse liite EN: ' + liitetyyppi" [disabled]="liiteUploadStatus()[liitetyyppi] === 'uploading'"> Valitse EN </app-primary-button>
              @if (liiteStatuses()[liitetyyppi]?.en === 'selected') {
                <mat-icon style="color: #1976d2">attach_file</mat-icon>
              }
            </div>
            <div style="display: flex; align-items: center; gap: 1em">
              <app-primary-button (click)="paivitaLiite(liitetyyppi)" [actionId]="'Päivitä liite: ' + liitetyyppi" [disabled]="!cachedBase64Map()[liitetyyppi]?.fi || !cachedBase64Map()[liitetyyppi]?.en || liiteUploadStatus()[liitetyyppi] === 'uploading'"> Päivitä liite </app-primary-button>
              @if (liiteUploadStatus()[liitetyyppi] === 'uploading') {
                <mat-spinner [diameter]="24"></mat-spinner>
              }
              @if (liiteUploadStatus()[liitetyyppi] === 'valid') {
                <mat-icon style="color: green">check_circle</mat-icon>
              }
              @if (liiteUploadStatus()[liitetyyppi] === 'error') {
                <mat-icon style="color: red">error</mat-icon>
              }
            </div>
          </div>
          <div style="display: flex; gap: 1em">
            @if (liiteUrls()[liitetyyppi]?.fi) {
              <div style="flex: 1">
                <div style="margin-bottom: 0.5em">Suomi (FI)</div>
                <iframe [src]="liiteUrls()[liitetyyppi].fi" style="width: 100%; height: 600px; border: 1px solid #ccc"></iframe>
              </div>
            }
            @if (liiteUrls()[liitetyyppi]?.en) {
              <div style="flex: 1">
                <div style="margin-bottom: 0.5em">Englanti (EN)</div>
                <iframe [src]="liiteUrls()[liitetyyppi].en" style="width: 100%; height: 600px; border: 1px solid #ccc"></iframe>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
